module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top_menu",
    class: {
      'transparent hidden-xs': _vm.transparent
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(!_vm.transparent) ? _c('div', {
    staticClass: "welcome_mssg hidden-xs"
  }, [_vm._v("\n            Hotel CEO Group\n        ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "top_menu_right"
  }, [_c('li', [_c('i', {
    staticClass: "fa  fa-phone"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.telefono
    }
  }, [_vm._v(" " + _vm._s(_vm.phone) + " ")])]), _vm._v(" "), _c('li', {
    staticClass: "email"
  }, [_c('i', {
    staticClass: "fa  fa-envelope-o "
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.correo
    }
  }, [_vm._v(_vm._s(_vm.email))])]), _vm._v(" "), _c('li', {
    staticClass: "language-switcher"
  }, [_c('nav', {
    staticClass: "dropdown"
  }, [(_vm.currentLanguage != null) ? _c('a', {
    staticClass: "dropdown-toggle select",
    attrs: {
      "href": "#",
      "data-hover": "dropdown",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    class: _vm.currentLanguage.icon
  }), _vm._v("\n                        " + _vm._s(_vm.tr(_vm.currentLanguage.id)) + " "), _c('b', {
    staticClass: "caret"
  })]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, _vm._l((_vm.languages), function(l) {
    return _c('li', {
      key: l.id
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.changeLanguage(l.id)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.tr(l.id)) + "\n                            ")])])
  }))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28d6a2d9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menuTransparent/MenuTransparent.vue
// module id = 354
// module chunks = 0